import {
  getStorefrontCopyValue,
  storefrontCopyForTenant,
} from "lib/storefrontCopy";

export const DEFAULT_STOREFRONT_ACCENT = "#FF5C00";
export const STOREFRONT_THEME_PRESETS = ["classic"];

export function normalizeStorefrontColor(
  value,
  fallback = DEFAULT_STOREFRONT_ACCENT,
) {
  const raw = String(value || "").trim();
  return /^#[0-9a-fA-F]{6}$/.test(raw) ? raw : fallback;
}

export function normalizeThemePreset(value) {
  return "classic";
}

export function normalizeHeroStyle(value) {
  return String(value || "")
    .trim()
    .toLowerCase() === "image"
    ? "image"
    : "text";
}

export function resolveStorefrontAssetUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^(https?:|data:|blob:)/i.test(raw)) return raw;
  return raw.startsWith("/") ? raw : `/${raw}`;
}

const PRESET_TOKENS = {
  classic: {
    name: "Classic",
    pageBg: "#FFFFFF",
    canvas: "#F7F8FA",
    surface: "#FFFFFF",
    ink: "#111827",
    muted: "#667085",
    line: "rgba(17,24,39,0.10)",
    headerBg: "rgba(255,255,255,0.92)",
    headerBorder: "rgba(31,41,51,0.08)",
    cardRadius: 18,
    panelRadius: 16,
    buttonRadius: 999,
    shadow: "0 18px 50px rgba(17,24,39,0.06)",
    strongShadow: "0 24px 70px rgba(17,24,39,0.08)",
    layout: "classic",
    portal: "rail",
    density: "balanced",
  },
};

export function storefrontThemeForTenant(tenant, locale) {
  const preset = normalizeThemePreset(tenant?.storefrontThemePreset);
  const tokens = PRESET_TOKENS[preset] || PRESET_TOKENS.classic;
  const copy = storefrontCopyForTenant(tenant, locale);
  const accent = normalizeStorefrontColor(
    tenant?.storefrontAccentColor,
    DEFAULT_STOREFRONT_ACCENT,
  );
  return {
    ...tokens,
    preset,
    accent,
    orange: "#F97316",
    name:
      String(tenant?.name || "").trim() ||
      getStorefrontCopyValue(copy, "common.brandFallback", "Storefront"),
    logoUrl: resolveStorefrontAssetUrl(tenant?.brandLogoUrl),
    headerTagline:
      String(tenant?.storefrontHeaderTagline || "").trim() ||
      getStorefrontCopyValue(copy, "common.headerTagline"),
    heroTitle:
      String(tenant?.storefrontHeroTitle || "").trim() ||
      getStorefrontCopyValue(copy, "home.heroTitle"),
    heroSubtitle:
      String(tenant?.storefrontHeroSubtitle || "").trim() ||
      getStorefrontCopyValue(copy, "home.heroSubtitle"),
    heroImageUrl: resolveStorefrontAssetUrl(tenant?.storefrontHeroImageUrl),
    heroStyle: normalizeHeroStyle(tenant?.storefrontHeroStyle),
  };
}
